import { render, staticRenderFns } from "./Finishing.vue?vue&type=template&id=5cd6bd0d&scoped=true&"
import script from "./Finishing.vue?vue&type=script&lang=js&"
export * from "./Finishing.vue?vue&type=script&lang=js&"
import style0 from "./Finishing.vue?vue&type=style&index=0&id=5cd6bd0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6bd0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd6bd0d')) {
      api.createRecord('5cd6bd0d', component.options)
    } else {
      api.reload('5cd6bd0d', component.options)
    }
    module.hot.accept("./Finishing.vue?vue&type=template&id=5cd6bd0d&scoped=true&", function () {
      api.rerender('5cd6bd0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/addKnowledge/finishing/Finishing.vue"
export default component.exports